module.exports = __webpack_public_path__ + "fonts/Poppins-SemiBold.4cdacb8f.ttf";